<template>
  <div :class="`header-${theme}`">
    <div>
      <span class="title" :style="`color: ${themeColor}`">{{ title }}</span>
      <span class="language" :style="`color: ${themeColor}`">
        {{ language }}
      </span>
      <span
        class="result"
        :style="`color: ${getResultTextColor}`"
        v-if="resultText && !loading"
      >
        {{ resultText }}
      </span>
    </div>
    <div>
      <template v-if="showCheckFullScreen">
        <img
          v-if="fullscreen"
          class="full-screen"
          :src="theme === 'dark' ? fullScreenDark : fullScreenLight"
          alt
          @click="screen"
        />
        <img
          v-if="!fullscreen"
          class="full-screen"
          :src="theme === 'dark' ? cancelFullScreenDark : cancelFullScreenLight"
          alt
          @click="screen"
        />
      </template>

      <button
        v-if="showDownload"
        class="download-button"
        :style="`color: ${themeColor}; border: 1px solid ${themeColor}`"
        :disabled="disabled"
        @click="download"
      >
        下载代码
      </button>
      <button
        class="run-button"
        :style="`backgroundColor: ${themeColor}`"
        @click="run"
        :disabled="loading || disabled"
      >
        <img
          class="loading"
          v-if="loading"
          src="../../assets/icon/loading-icon.svg"
        />
        <div style="display: inline-block">{{ runText }}</div>
      </button>
    </div>
  </div>
</template>
<script type="text/babel">
import loadingUrl from "../../assets/icon/loading-icon.svg";
import fullScreenLight from "../../assets/icon/full-screen.svg";
import fullScreenDark from "../../assets/icon/full-screen-dark.svg";
import cancelFullScreenLight from "../../assets/icon/cancel-full-screen.svg";
import cancelFullScreenDark from "../../assets/icon/cancel-full-screen-dark.svg";

export default {
  props: {
    title: {
      type: String,
      default: "课堂练习"
    },
    runText: {
      type: String,
      default: "执行"
    },
    // 主题颜色
    themeColor: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 主题类型 ['dark', 'light']
    theme: {
      type: String,
      default: "dark"
    },
    // 是否显示下载按钮
    showDownload: {
      type: Boolean,
      default: true
    },
    // 校验结果的文案
    resultText: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    showCheckFullScreen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fullscreen: false,
      cancelFullScreenDark,
      cancelFullScreenLight,
      fullScreenLight,
      fullScreenDark
    };
  },
  computed: {
    getResultTextColor() {
      if (this.resultText === "答案正确" || this.resultText === "运行成功") {
        return this.themeColor;
      }
      return "#f5222d";
    }
  },
  created() {
    // Esc事件
    let that = this;
    window.onresize = function() {
      if (!that.checkFull()) {
        that.fullscreen = false;
      }
    };
  },
  methods: {
    run() {
      this.$emit("run");
    },
    screen() {
      let element = document.getElementById("code-component");
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    checkFull() {
      //判断浏览器是否处于全屏状态
      var isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        //谷歌浏览器及Webkit内核浏览器
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
    download() {
      // 为了取值方便，emit出去
      this.$emit("download");
    }
  }
};
</script>
<style scoped>
.header-light {
  color: #0fc700;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
}
.header-dark {
  color: #0fc700;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #666;
}
.title {
  min-width: 80px;
  /* margin-left: 125px; */
}
.language {
  margin: auto 20px;
}
.run-button {
  color: #fff;
  border: none;
  height: 30px;
  min-width: 90px;
  cursor: pointer;
  display: inline-block;
  justify-content: center;
  line-height: 30px;
}
.download-button {
  background-color: transparent;
  outline: none;
  height: 28px;
  min-width: 90px;
  cursor: pointer;
  border: none;
  margin-right: 10px;
}
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
.loading {
  width: 17px;
  height: 17px;
  margin: auto 2px;
  animation: rotation 2s linear infinite;
  -moz-animation: rotation 2s linear infinite;
  -webkit-animation: rotation 2s linear infinite;
  -o-animation: rotation 2s linear infinite;
}
.full-screen {
  width: 22px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 10px;
}
</style>
